const typographyModalPlaces = {
  true: 'Editar ',
  false: 'Registrar ',
  text: 'Raíz'
};

export default typographyModalPlaces;
